import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import calculatePercentage from '€lib/dashboard/calculatePercentage';
import { getCommission } from '€slices/stats/stats-selectors';

const useCommission = () => {
    const commissionData = useSelector(getCommission);
    const thisYearsAmount = commissionData.current.year;
    const lastYearsAmount = commissionData.previous.year;
    const thisMonthsAmount = commissionData.current.month;
    const lastMonthsAmount = commissionData.previous.month;

    const monthlyPercentage = useMemo(
        () => calculatePercentage(lastMonthsAmount, thisMonthsAmount),
        [lastMonthsAmount, thisMonthsAmount],
    );
    const annualPercentage = useMemo(
        () => calculatePercentage(lastYearsAmount, thisYearsAmount),
        [lastYearsAmount, thisYearsAmount],
    );

    return {
        thisYearsAmount,
        thisMonthsAmount,
        monthlyPercentage,
        annualPercentage,
    };
};

export default useCommission;
